module.exports = __webpack_public_path__ + "static/img/systemli1.90acd26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/scheme/systemli1.png
// module id = yXT1
// module chunks = 1